import React, {AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode} from "react";
import {cn} from "@/lib/utils";

const BASE_CLASSES =
    "font-semibold text-[12px] leading-none p-[12px] bg-gray border-2 border-stroke-gray rounded-[8px] text-white opacity-[50%] cursor-pointer";

// Renders a `<button>` by default; pass `href` to render a styled `<a>` instead
// (used for progressive-enhancement CTAs that must work before hydration).
type CtaBtnProps =
    | ({children: ReactNode; href?: undefined} & ButtonHTMLAttributes<HTMLButtonElement>)
    | ({children: ReactNode; href: string} & AnchorHTMLAttributes<HTMLAnchorElement>);

export const CtaBtn = (props: CtaBtnProps) => {
    if (props.href !== undefined) {
        const {children, className, ...rest} = props;
        return (
            <a className={cn(BASE_CLASSES, 'flex items-center justify-center', className)} {...rest}>
                {children}
            </a>
        );
    }

    const {children, className, ...rest} = props;
    return (
        <button className={cn(BASE_CLASSES, className)} {...rest}>
            {children}
        </button>
    );
};
